import React from 'react';
import { useTranslation } from '@whoop/i18n/lang/client';
import type { CartButtonVariants } from './CartCTAButtons';
import { useJoinFlowButtonLogic } from './useJoinFlowButtonLogic';
import { CartButtons } from './CartButtons';
import { JOIN_FLOW_STEPS } from '@/lib/constants/maverick';
import { useGetCurrentPageMaverick } from '@/hooks/useGetCurrentPageMaverick';
import { useSiteStore } from '@/store/SiteStoreProvider';
import { useShallow } from 'zustand/react/shallow';
import { hasProductTypeInCartItemGroups } from '../cart.utils';
import { ProductType } from '@/lib/constants/maverick';
interface JoinFlowButtonsProps {
  showOnlyPrimaryButton: boolean;
  variant: CartButtonVariants;
  skipMemSelectFlow?: string;
  showTrialBlock?: boolean;
}
export function JoinFlowButtons({
  showOnlyPrimaryButton,
  variant,
  skipMemSelectFlow,
  showTrialBlock
}: JoinFlowButtonsProps) {
  const {
    t
  } = useTranslation('cart');
  const {
    setIsCartOpen,
    cart
  } = useSiteStore(useShallow(state => ({
    setIsCartOpen: state.setIsCartOpen,
    cart: state.cart
  })));
  const {
    buttonsVariant,
    primaryButtonActionVariants,
    secondaryButtonActionVariants,
    primaryButtonLabelVariants,
    secondaryButtonLabelVariants,
    onContinueToCheckout
  } = useJoinFlowButtonLogic({
    variant,
    skipMemSelectFlow,
    showTrialBlock
  });
  const page = useGetCurrentPageMaverick();
  const isAccessoriesPage = page === JOIN_FLOW_STEPS.ACCESSORIES;
  const isLandingPage = page === JOIN_FLOW_STEPS.JOIN;
  const isBandsPage = page === JOIN_FLOW_STEPS.BANDS;
  const isFamilyPage = page === JOIN_FLOW_STEPS.FAMILY;
  const isMembershipPage = page === JOIN_FLOW_STEPS.MEMBERSHIP;

  // Check cart contents for determining secondary button visibility

  const hasMembershipInCart = hasProductTypeInCartItemGroups(cart.cartItemGroups, ProductType.MEMBERSHIP);
  const {
    primaryButtonLabel,
    primaryButtonAction
  } = isAccessoriesPage ? {
    primaryButtonLabel: t('continueToCheckout'),
    primaryButtonAction: onContinueToCheckout
  } : {
    primaryButtonLabel: primaryButtonLabelVariants[buttonsVariant],
    primaryButtonAction: primaryButtonActionVariants[buttonsVariant]
  };

  // Determine if we should show secondary button
  const shouldShowSecondaryButton = (isLandingPage || isMembershipPage || isFamilyPage || isBandsPage) && Boolean(secondaryButtonLabelVariants[buttonsVariant]) && Boolean(secondaryButtonActionVariants[buttonsVariant]) && hasMembershipInCart;
  return <CartButtons primaryButtonLabel={primaryButtonLabel} primaryButtonAction={() => {
    primaryButtonAction?.();
  }} showSecondaryButton={shouldShowSecondaryButton} secondaryButtonLabel={secondaryButtonLabelVariants[buttonsVariant]} secondaryButtonAction={secondaryButtonActionVariants[buttonsVariant]} showKeepShoppingButton={isAccessoriesPage} keepShoppingAction={() => setIsCartOpen(false)} keepShoppingLabel={t('keepShopping')} showOnlyPrimaryButton={showOnlyPrimaryButton} data-sentry-element="CartButtons" data-sentry-component="JoinFlowButtons" data-sentry-source-file="JoinFlowButtons.tsx" />;
}